module.exports = __webpack_public_path__ + "static/strefy-wejscia-22aa5765c39a06182604ea9f113f908c.jpg";